import { Injectable } from '@angular/core'
import { DialogService } from '@tokeet-frontend/tv3-platform'
import { AutomationsDialogComponent } from './automations-dialog.component'

@Injectable()
export class AutomationsDialogService {
  constructor(private dialog: DialogService) {}

  open() {
    return this.dialog.openDrawer(AutomationsDialogComponent, {
      panelClass: 'drawer-full-80',
      data: {},
    })
  }
}
